export class Work {

  constructor() {
    this.object_id = null;
    this.player_id = null;
    this.target_id = null;
    this.category = null;
    this.block_start = null;
    this.difficulty_target = null;
  }

}
